const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- api-explorer ---
let __fez_component_0;
{

__fez_component_0 = class {
  init() {
    this.state.schema = null
    this.state.error = ''
    this.state.query = ''
    this.state.hash = window.location.hash
    this.on(window, 'hashchange', () => {
      this.state.hash = window.location.hash
      this.state.main?.scrollTo?.(0, 0)
    })
    this.load()
  }

  async load() {
    try {
      const response = await fetch('/api/sys/schema.json')
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      this.state.schema = await response.json()
    } catch (error) {
      this.state.error = `Could not load the API schema (${error.message}).`
    }
  }

  search(value) {
    this.state.query = value.trim().toLowerCase()
  }

  beforeRender() {
    const schema = this.state.schema
    if (!schema) return
    const key = decodeURIComponent(this.state.hash.replace(/^#\/?/, ''))
    this.state.current = schema.actions.find((a) => a.path === key) || null
    const query = this.state.query
    const groups = new Map()
    for (const action of schema.actions) {
      const text = `${action.path} ${action.summary}`.toLowerCase()
      if (query && !text.includes(query)) continue
      if (!groups.has(action.group)) groups.set(action.group, [])
      groups.get(action.group).push(action)
    }
    this.state.groups = [...groups.entries()].map(([name, actions]) => ({ name, actions }))
  }

  CSS = `:fez {
display:block;height:100vh;height:100dvh;.shell{display:grid;grid-template-rows:auto 1fr;height:100%}.top{display:flex;align-items:center;gap:var(--space-4);height:56px;padding:0 var(--space-5);border-bottom:1px solid var(--color-border);background:var(--color-bg-raised)}.brand{display:flex;align-items:center;gap:var(--space-3);color:var(--color-text);font-weight:var(--weight-bold);text-decoration:none;&:hover{text-decoration:none}}.mark{display:grid;place-items:center;width:30px;height:30px;border-radius:var(--radius-md);background:var(--color-accent);color:var(--color-accent-text)}.files{display:flex;gap:var(--space-4);margin-left:auto;font-size:var(--text-sm)}.body{display:grid;grid-template-columns:300px minmax(0,1fr);min-height:0}aside{display:flex;flex-direction:column;min-height:0;border-right:1px solid var(--color-border);background:var(--color-bg-subtle)}.search{padding:var(--space-4)}nav{flex:1;overflow-y:auto;padding:0 var(--space-3) var(--space-6)}.overview{display:flex;align-items:center;gap:var(--space-2);margin-bottom:var(--space-3)}.group{margin:var(--space-4) var(--space-3) var(--space-1);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.link{display:block;padding:6px var(--space-3);border-radius:var(--radius-md);color:var(--color-text);font-size:var(--text-sm);text-decoration:none;&:hover{background:var(--color-bg-hover);text-decoration:none}&.active{background:var(--color-selected-bg);color:var(--color-selected-text);font-weight:var(--weight-semibold)}code{font-size:var(--text-sm)}}main{overflow-y:auto}.center{display:grid;place-items:center;height:100%}.none{padding:var(--space-3);color:var(--color-text-muted);font-size:var(--text-sm)} :mobile {display:block;height:auto;.body{grid-template-columns:1fr}aside{border-right:0;border-bottom:1px solid var(--color-border)}nav{max-height:40vh}.files{display:none}}
}`

  HTML = `<div class="shell">
<header class="top">
<a class="brand" href="#/">
<span class="mark"><ui-icon name="envelope-simple" size="18" weight="fill"></ui-icon></span>
<span>MailCog API</span>
{#if state.schema}
<ui-badge label="v{state.schema.version}"></ui-badge>
{/if}
</a>
<div class="files">
<a href="/api/sys/openapi.json" target="_blank" rel="noopener">openapi.json</a>
<a href="/api/sys/schema.json" target="_blank" rel="noopener">schema.json</a>
<a href="/api/sys/AGENTS.md" target="_blank" rel="noopener">AGENTS.md</a>
</div>
<ui-button size="sm" href="/" label="Open app" icon_right="arrow-right"></ui-button>
</header>

{#if state.error}
<div class="center"><ui-empty icon="warning-circle" title="Something went wrong" text={state.error}></ui-empty></div>
{:else if !state.schema}
<div class="center"><ui-spinner size="lg"></ui-spinner></div>
{:else}
<div class="body">
<aside>
<div class="search" oninput="fez.search(event.target.value)">
<ui-input name="q" icon="magnifying-glass" placeholder="Search actions"></ui-input>
</div>
<nav aria-label="Actions">
<a class="link overview" class:active={!state.current} href="#/"><ui-icon name="book-open" size="16"></ui-icon> Overview</a>
{#each state.groups as group}
<div class="group">{group.name}</div>
{#each group.actions as action}
<a class="link" class:active={state.current && state.current.path === action.path} href="#/{action.path}"><code>{action.path}</code></a>
{/each}
{:else}
<p class="none">No actions match.</p>
{/each}
</nav>
</aside>
<main fez:this="main">
{#if state.current}
<div fez:keep="action-{state.current.path}">
<api-action :action="state.current" :defs="state.schema.\$defs"></api-action>
</div>
{:else}
<api-overview :schema="state.schema"></api-overview>
{/if}
</main>
</div>
{/if}
</div>`
};
}

Fez('api-explorer', __fez_component_0);

export default __fez_component_0;
